import { defineMessages } from "react-intl";

import {
	syphilisScreeningMessages,
	validator
} from "lib/build/forms/htx/microbiological-procedures/treponemaPallidum";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	treponemaPallidum: {
		id: "form.treponema_pallidum",
		defaultMessage: "Treponema pallidum (szifilisz)"
	},
	syphilisScreening: {
		id: "form.treponema_pallidum.syphilis_screening",
		defaultMessage: "Szifilisz szűrés"
	}
});

const fields: { [key: string]: FieldData } = {
	syphilisScreening: {
		type: "field",
		path: ["syphilisScreening"],
		label: messages.syphilisScreening,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: syphilisScreeningMessages }
		}
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.syphilisScreening }] }]
};

export const node: LeafNode = {
	id: "treponemaPallidum",
	value: {
		title: messages.treponemaPallidum,
		validator,
		fieldset,
		isImportant: true
	}
};
